import React from 'react';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import './styles.css';
const DependentSignUpConformation = (props) => {
  const {
    history,
    classes: {
      container,
      containerForm,
      headerText,
      addAnotherButton,
      goBackButton,
    },
  } = props

  return (
    <div className={container}>
      <Grid container spacing={8} className={containerForm}>
        <Grid item xs={12}>
          <h2 className={headerText}>Dependent has been signed up.<br/>Thank you for expanding the Qwell family!</h2>

          <Button className = {addAnotherButton}
            onClick={() => history.push(`/sign-up/dependent-patient-signup`)}
            color="primary"
            variant="contained"
          >
            add another dependent
          </Button>

          <Button className = {goBackButton}
            onClick={() => history.push(`/patients`)}
            color="primary"
            variant="contained"
          >
            go back to your profile
          </Button>
        </Grid>
       </Grid>
    </div>
  );
};

const styles = () => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'center',
  },
  containerForm: {
    width: '60%',
    height: '600px',
    padding: '1rem',
    paddingTop: '90px',
    '@media only screen and (max-width: 1024px)': {
      width: '100%',
    },
  },
  headerText: {
    color: '#1C1C1C',
    fontSize: '40px',
    fontWeight: '300',
    lineHeight: '47px',
    paddingBottom: '25px',
  },
  addAnotherButton: {
    marginTop: '40px'
  },
  goBackButton: {
    marginTop: '40px',
    marginLeft: '20px'
  },
});

export default withRouter(withStyles(styles)(DependentSignUpConformation));
